import classNames from 'classnames';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { Blog } from './DataDefinitions';


interface BlogInformationFormProps {
  className?: string;
  initialData?: Blog;
  onUpdate: (data: any) => void; // Function to update form data in parent component
}

const BlogForm = ({ className, onUpdate, initialData }: BlogInformationFormProps) => {

  // State to store the form data
  const [formData, setFormData] = useState<any>({
    title: '',
    topic: '',
    type: '',
    description: '',
    active: false,
    sponsored: false,
    lang: '',
    url: ''
  });

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    onUpdate({ ...formData, [name]: value }); // Update the parent component's formData on every change
  };

  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setFormData({ ...formData, [name]: checked });
    onUpdate({ ...formData, [name]: checked }); // Update the parent component's formData on every change

  };

  useEffect(() => {
    if (initialData) {
      setFormData({
        title: initialData['title'],
        type: initialData['type'],
        topic: initialData['topic'],
        description: initialData['description'],
        active: initialData['active'],
        sponsored: initialData['sponsored'],
        lang: initialData['lang'],
        url: initialData['url']
      });
    }
  }, [initialData]);

  return (
    <>
      <h4 className="mb-3">Blog Information</h4>

      <Row className={classNames('g-3', className)}>


        <Col sm={6} md={6}>
          <FloatingLabel controlId="type" label="type">
            <Form.Control as="select" placeholder="type" required
              name='type' value={formData.type} onChange={handleInputChange} >
              <option>Open this select menu</option>
              <option value="events">Event</option>
              <option value="magazine">Magazine</option>
              <option value="forum">Forum</option>

            </Form.Control>
          </FloatingLabel>
        </Col>


        <Col sm={6} md={6}>
          <FloatingLabel controlId="topic" label="topic">
            <Form.Control as="select" placeholder="topic" required
              name='topic' value={formData.topic} onChange={handleInputChange} >


              <option>Open this select menu</option>
              <option value="AI & Digital Transformation">AI & Digital Transformation</option>
              <option value="Sustainability">Sustainability</option>
              <option value="Leadership & Interpesonal Skills">Leadership & Interpesonal Skills</option>
              <option value="Business Management & Strategy">Business Management & Strategy</option>
              <option value="Data Science & Analysis">Data Science & Analysis</option>
              <option value="Education">Education</option>
              <option value="Finance">Finance</option>

            </Form.Control>
          </FloatingLabel>
        </Col>

        <Col sm={12} md={12}>
          <FloatingLabel controlId="title" label="Title *">
            <Form.Control type="text" placeholder="title *"
              name='title' value={formData.title} onChange={handleInputChange} required
            />
          </FloatingLabel>
        </Col>



        <Col sm={12} md={12}>
          <FloatingLabel label="Description *">
            <Form.Control
              as="textarea"
              style={{ height: '128px' }}
              type="text"
              placeholder="Description *"
              name='description' value={formData.description} onChange={handleInputChange} required />
          </FloatingLabel>
        </Col>

        <Col sm={12} md={12}>
          <FloatingLabel controlId="url" label="url">
            <Form.Control type="text" placeholder="url"
              name='url' value={formData.url} onChange={handleInputChange}
            />
          </FloatingLabel>
        </Col>



        <Col sm={6} md={4}>
          <FloatingLabel controlId="lang" label="lang">
            <Form.Control as="select" placeholder="lang"
              name='lang' value={formData.lang} onChange={handleInputChange} >

              <option>-</option>
              <option value="en">English</option>
              <option value="it">Italian</option>
              <option value="fr">French</option>
            </Form.Control>
          </FloatingLabel>
        </Col>

        <Col sm={6} md={4}>
          <div className="form-icon-container">

            <Form.Check
              type="checkbox"
              id="active"
              name="active"
              label="Active"
              checked={formData.active}
              onChange={handleCheckChange}
            />
          </div>
        </Col>
        <Col sm={6} md={4}>
          <div className="form-icon-container">

            <Form.Check
              type="checkbox"
              id="sponsored"
              name="sponsored"
              label="Sponsor"
              checked={formData.sponsored}
              onChange={handleCheckChange}
            />
          </div>
        </Col>




      </Row>
    </>
  );
};

export default BlogForm;

